module.exports = __webpack_public_path__ + "static/media/malarn_open.3d0ed68a.jpg";